import RouteConfiq from "../../Routing/routes";
import PageError500 from "../../Components/PageError/PageError";
import PasswordProtectedModal from "./PasswordProtectedModal";
import useAuthFlow from "./useAuthFlow";
import Loader from "../../Components/Loader/Loader";
import useBreadcrumb from "../../hooks/useBreadcrumb";


const Auth = () => {
  const { authState, showModal, passwordConfig, handleCloseModal } = useAuthFlow();
  useBreadcrumb();

  if (showModal) {
    return (
      <PasswordProtectedModal
        show
        isprotectedDescription={passwordConfig.description}
        handleClose={handleCloseModal}
      />
    );
  }

  if (authState.hasError) {
    return <PageError500 pageError={authState.pageError} />;
  }

  if (!authState.isAuthenticated) {
    return <Loader />;
  }

  return <RouteConfiq />;
};

export default Auth;
